import { render, staticRenderFns } from "./De.vue?vue&type=template&id=2976713b&scoped=true&"
import script from "./De.vue?vue&type=script&lang=js&"
export * from "./De.vue?vue&type=script&lang=js&"
import style0 from "./De.vue?vue&type=style&index=0&id=2976713b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2976713b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VMain,VRow})
